// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Verification-space1-ta3xT {
	margin-bottom: 6px !important;
}

.Verification-space2-nhzFJ {
	margin-bottom: 12px !important;
}

.Verification-space3-j04UO {
	margin-bottom: 18px !important;
}

.Verification-space4-A9B4l {
	margin-bottom: 24px !important;
}

.Verification-space5-qyzNG {
	margin-bottom: 30px !important;
}

.Verification-space6-rMFT4 {
	margin-bottom: 36px !important;
}

.Verification-space7-CUT8Q {
	margin-bottom: 42px !important;
}

.Verification-spaceTop8-GZCAz {
	margin-bottom: 48px !important;
}

.Verification-spaceTop1-ZYiJe {
	margin-top: 6px !important;
}

.Verification-spaceTop2-YaIBn {
	margin-top: 12px !important;
}

.Verification-spaceTop3-tZAh0 {
	margin-top: 18px !important;
}

.Verification-spaceTop4-P8OQJ {
	margin-top: 24px !important;
}

.Verification-spaceTop5-TYvdL {
	margin-top: 30px !important;
}

.Verification-spaceTop6-yOTjU {
	margin-top: 36px !important;
}

.Verification-spaceTop7-FD9Tu {
	margin-top: 42px !important;
}

.Verification-spaceTop8-GZCAz {
	margin-top: 48px !important;
}

.Verification-noMargin-3c0Mr {
	margin: 0px !important;
}

.Verification-padding1-UQAmP {
	padding-bottom: 6px !important;
}

.Verification-padding2-wpAz7 {
	padding-bottom: 12px !important;
}

.Verification-padding3-edp6F {
	padding-bottom: 18px !important;
}

.Verification-padding4-LoJwa {
	padding-bottom: 24px !important;
}

.Verification-padding5-ijLYo {
	padding-bottom: 30px !important;
}

.Verification-padding6-fTDxw {
	padding-bottom: 36px !important;
}

.Verification-padding7-qsBsB {
	padding-bottom: 42px !important;
}

.Verification-paddingTop1-AH7YR {
	padding-top: 6px !important;
}

.Verification-paddingTop2-BTk7E {
	padding-top: 12px !important;
}

.Verification-paddingTop3-flbDe {
	padding-top: 18px !important;
}

.Verification-paddingTop4-CiJY6 {
	padding-top: 24px !important;
}

.Verification-paddingTop5-wRzyg {
	padding-top: 30px !important;
}

.Verification-paddingTop6-NPT63 {
	padding-top: 36px !important;
}

.Verification-paddingTop7-qjzKm {
	padding-top: 42px !important;
}

.Verification-noPadding-Ojhkw {
	padding: 0px !important;
}

.Verification-textBold-x762i {
	font-weight: 500 !important;
}

.Verification-textBolder-rSc5k {
	font-weight: 700 !important;
}

.Verification-textNormal-lAPGD {
	font-weight: normal !important;
}

.Verification-spaceBottom20-fE53s {
	margin-bottom: 20px;
}

.Verification-spaceBottom10-RZEYi {
	margin-bottom: 10px;
}

.Verification-marginNone-sEoRR {
	margin: 0;
}

.Verification-spaceBottom15-XDR5j {
	margin-bottom: 15px;
}

.Verification-marginTopNone-vh3fi {
	margin-top: 0;
}

.Verification-spaceTop11-OlyD4 {
	margin-top: 11px;
}

.Verification-spaceTop21-IxZcL {
	margin-top: 21px;
}

.Verification-spaceTop20-eYdoM {
	margin-top: 20px;
}

.Verification-spaceTop10-f8YB9 {
	margin-top: 10px;
}

/*New Design Text Colors */

.Verification-textDarkBlue-ntirX {
	color: rgb(20, 39, 94) !important;
}

.Verification-textLightBlue-YVAaL {
	color: rgb(57, 87, 106) !important;
}

.Verification-textLightSandleGreen-OSMp6 {
	color: rgb(76, 86, 41) !important;
}

.Verification-textLightBrown-rEOux {
	color: rgb(115, 79, 33) !important;
}

.Verification-textMediumMaroon-IzWB9 {
	color: rgb(87, 37, 51) !important;
}

.Verification-textBrown-Wf7SE {
	color: rgb(160, 47, 24) !important;
}

.Verification-textMaroon-Z8Guc {
	color: rgb(155, 49, 67) !important;
}

.Verification-textDarkBrown-yzQWz {
	color: rgb(83, 18, 16) !important;
}

.Verification-textMediumBrown-AbSjQ {
	color: rgb(142, 28, 10) !important;
}

.Verification-textSkyBlue-zMniV {
	color: rgb(37, 117, 141) !important;
}

.Verification-textGray-a0JZL {
	color: rgb(77, 65, 51) !important;
}

.Verification-button-Gya8d {
  display: block;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  margin: 0;
  padding: 10px 16px;
  width: 100%;
  outline: 0;
  border: 1px solid var(--primary-bg);
  border-radius: 4px;
  background: var(--primary-bg);
  color: var(var(--primary-foreground));
  text-align: center;
  text-decoration: none;
  font-size: 18px;
  line-height: 1.3333333;
  cursor: pointer;
}

.Verification-button-Gya8d:hover {
  background: var(--primary-bg);
}

.Verification-noMargin-3c0Mr {
  margin: 0px;
}

.Verification-noBorder-beV_0 {
  border: 0px none !important;
}

.Verification-iconContainer-uYjI5 {
	border-radius: 50%;
	border: 3px solid var(--primary-border);
	display: inline-block;
	width: 90px;
	height: 90px;
}

.Verification-iconEnvelope-CCsCf {
	font-style: normal;
	font-weight: normal;
	line-height: 1;
}

.Verification-iconSize-rUBPp {
	font-size: 3.6em;
}

.Verification-iconGray-V5G3N {
	color: var(--secondary-foreground);
	height: 80px;
	width: 80px;
}

.Verification-formGroup-oLF36 {
	margin-bottom: 6px;
}

.Verification-activationStepPanel-eOL18 {
	max-width: 530px;
	margin: 0 auto;
	height: 100%;
	min-height: 520px;
	text-align: center;
	border: none;
}

.Verification-panelBody-FIqUl {
	position: relative;
	padding-top: 35px;
	padding-bottom: 35px;
	padding-left: 60px;
	padding-right: 60px;
}

a,
a:hover,
a:focus,
a:active {
	color: var(--primary-link-foreground);
	text-decoration: none;
}

.Verification-refreshSection-X_cxG {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 10px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.Verification-refreshImage-kYEQT {
	border: 1px solid var(--primary-border);
	border-radius: 50%;
	padding: 10px;
	cursor: pointer;
	width: 40px;
	height: 40px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.Verification-refreshImage-kYEQT>svg {
	width: 100%;
	height: 100%;
	color: var(--primary-bg);
}

@media screen and (max-width: 767px) {
	.Verification-panelBody-FIqUl {
		padding-left: 10px;
		padding-right: 10px;
	}

}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Booking/common.css","webpack://./src/components/Booking/Verification/Verification.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;EACE,cAAc;EACd,8BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AC5BA;CACC,kBAAkB;CAClB,uCAAuC;CACvC,qBAAqB;CACrB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kCAAkC;CAClC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;;;;CAIC,qCAAqC;CACrC,qBAAqB;AACtB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,mBAAe;KAAf,eAAe;CACf,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,eAAe;CACf,WAAW;CACX,YAAY;CACZ,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,wBAAwB;AACzB;;AAGA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;AAED","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.button {\n  display: block;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 10px 16px;\n  width: 100%;\n  outline: 0;\n  border: 1px solid var(--primary-bg);\n  border-radius: 4px;\n  background: var(--primary-bg);\n  color: var(var(--primary-foreground));\n  text-align: center;\n  text-decoration: none;\n  font-size: 18px;\n  line-height: 1.3333333;\n  cursor: pointer;\n}\n\n.button:hover {\n  background: var(--primary-bg);\n}\n\n.noMargin {\n  margin: 0px;\n}\n\n.noBorder {\n  border: 0px none !important;\n}","@import '../common.css';\n\n.iconContainer {\n\tborder-radius: 50%;\n\tborder: 3px solid var(--primary-border);\n\tdisplay: inline-block;\n\twidth: 90px;\n\theight: 90px;\n}\n\n.iconEnvelope {\n\tfont-style: normal;\n\tfont-weight: normal;\n\tline-height: 1;\n}\n\n.iconSize {\n\tfont-size: 3.6em;\n}\n\n.iconGray {\n\tcolor: var(--secondary-foreground);\n\theight: 80px;\n\twidth: 80px;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.activationStepPanel {\n\tmax-width: 530px;\n\tmargin: 0 auto;\n\theight: 100%;\n\tmin-height: 520px;\n\ttext-align: center;\n\tborder: none;\n}\n\n.panelBody {\n\tposition: relative;\n\tpadding-top: 35px;\n\tpadding-bottom: 35px;\n\tpadding-left: 60px;\n\tpadding-right: 60px;\n}\n\na,\na:hover,\na:focus,\na:active {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: none;\n}\n\n.refreshSection {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n}\n\n.refreshImage {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 50%;\n\tpadding: 10px;\n\tcursor: pointer;\n\twidth: 40px;\n\theight: 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.refreshImage>svg {\n\twidth: 100%;\n\theight: 100%;\n\tcolor: var(--primary-bg);\n}\n\n\n@media screen and (max-width: 767px) {\n\t.panelBody {\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Verification-space1-ta3xT`,
	"space2": `Verification-space2-nhzFJ`,
	"space3": `Verification-space3-j04UO`,
	"space4": `Verification-space4-A9B4l`,
	"space5": `Verification-space5-qyzNG`,
	"space6": `Verification-space6-rMFT4`,
	"space7": `Verification-space7-CUT8Q`,
	"spaceTop8": `Verification-spaceTop8-GZCAz`,
	"spaceTop1": `Verification-spaceTop1-ZYiJe`,
	"spaceTop2": `Verification-spaceTop2-YaIBn`,
	"spaceTop3": `Verification-spaceTop3-tZAh0`,
	"spaceTop4": `Verification-spaceTop4-P8OQJ`,
	"spaceTop5": `Verification-spaceTop5-TYvdL`,
	"spaceTop6": `Verification-spaceTop6-yOTjU`,
	"spaceTop7": `Verification-spaceTop7-FD9Tu`,
	"noMargin": `Verification-noMargin-3c0Mr`,
	"padding1": `Verification-padding1-UQAmP`,
	"padding2": `Verification-padding2-wpAz7`,
	"padding3": `Verification-padding3-edp6F`,
	"padding4": `Verification-padding4-LoJwa`,
	"padding5": `Verification-padding5-ijLYo`,
	"padding6": `Verification-padding6-fTDxw`,
	"padding7": `Verification-padding7-qsBsB`,
	"paddingTop1": `Verification-paddingTop1-AH7YR`,
	"paddingTop2": `Verification-paddingTop2-BTk7E`,
	"paddingTop3": `Verification-paddingTop3-flbDe`,
	"paddingTop4": `Verification-paddingTop4-CiJY6`,
	"paddingTop5": `Verification-paddingTop5-wRzyg`,
	"paddingTop6": `Verification-paddingTop6-NPT63`,
	"paddingTop7": `Verification-paddingTop7-qjzKm`,
	"noPadding": `Verification-noPadding-Ojhkw`,
	"textBold": `Verification-textBold-x762i`,
	"textBolder": `Verification-textBolder-rSc5k`,
	"textNormal": `Verification-textNormal-lAPGD`,
	"spaceBottom20": `Verification-spaceBottom20-fE53s`,
	"spaceBottom10": `Verification-spaceBottom10-RZEYi`,
	"marginNone": `Verification-marginNone-sEoRR`,
	"spaceBottom15": `Verification-spaceBottom15-XDR5j`,
	"marginTopNone": `Verification-marginTopNone-vh3fi`,
	"spaceTop11": `Verification-spaceTop11-OlyD4`,
	"spaceTop21": `Verification-spaceTop21-IxZcL`,
	"spaceTop20": `Verification-spaceTop20-eYdoM`,
	"spaceTop10": `Verification-spaceTop10-f8YB9`,
	"textDarkBlue": `Verification-textDarkBlue-ntirX`,
	"textLightBlue": `Verification-textLightBlue-YVAaL`,
	"textLightSandleGreen": `Verification-textLightSandleGreen-OSMp6`,
	"textLightBrown": `Verification-textLightBrown-rEOux`,
	"textMediumMaroon": `Verification-textMediumMaroon-IzWB9`,
	"textBrown": `Verification-textBrown-Wf7SE`,
	"textMaroon": `Verification-textMaroon-Z8Guc`,
	"textDarkBrown": `Verification-textDarkBrown-yzQWz`,
	"textMediumBrown": `Verification-textMediumBrown-AbSjQ`,
	"textSkyBlue": `Verification-textSkyBlue-zMniV`,
	"textGray": `Verification-textGray-a0JZL`,
	"button": `Verification-button-Gya8d`,
	"noBorder": `Verification-noBorder-beV_0`,
	"iconContainer": `Verification-iconContainer-uYjI5`,
	"iconEnvelope": `Verification-iconEnvelope-CCsCf`,
	"iconSize": `Verification-iconSize-rUBPp`,
	"iconGray": `Verification-iconGray-V5G3N`,
	"formGroup": `Verification-formGroup-oLF36`,
	"activationStepPanel": `Verification-activationStepPanel-eOL18`,
	"panelBody": `Verification-panelBody-FIqUl`,
	"refreshSection": `Verification-refreshSection-X_cxG`,
	"refreshImage": `Verification-refreshImage-kYEQT`
};
module.exports = ___CSS_LOADER_EXPORT___;
